/*!
 * Copyright (c) 2022 WEBLIFE
 *
 * Permission is granted to use this file for the period specified in the contract 
 * between WEBLIFE and the client. Usage of this file beyond the contract period 
 * is strictly prohibited unless an extended license or written permission is obtained.
 *
 * Modifying or editing this file without prior written consent from WEBLIFE 
 * is not permitted.
 *
 * THE FILE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, 
 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A 
 * PARTICULAR PURPOSE AND NONINFRINGEMENT.
 */
const POSTAL_CODE_API_URL = "/apps/app-proxy/address/postal-code",
  PROVINCE_CODE_TO_NAME = {
    1: "北海道",
    2: "青森県",
    3: "岩手県",
    4: "宮城県",
    5: "秋田県",
    6: "山形県",
    7: "福島県",
    8: "茨城県",
    9: "栃木県",
    10: "群馬県",
    11: "埼玉県",
    12: "千葉県",
    13: "東京都",
    14: "神奈川県",
    15: "新潟県",
    16: "富山県",
    17: "石川県",
    18: "福井県",
    19: "山梨県",
    20: "長野県",
    21: "岐阜県",
    22: "静岡県",
    23: "愛知県",
    24: "三重県",
    25: "滋賀県",
    26: "京都府",
    27: "大阪府",
    28: "兵庫県",
    29: "奈良県",
    30: "和歌山県",
    31: "鳥取県",
    32: "島根県",
    33: "岡山県",
    34: "広島県",
    35: "山口県",
    36: "徳島県",
    37: "香川県",
    38: "愛媛県",
    39: "高知県",
    40: "福岡県",
    41: "佐賀県",
    42: "長崎県",
    43: "熊本県",
    44: "大分県",
    45: "宮崎県",
    46: "鹿児島県",
    47: "沖縄県",
  };
async function lookupPostalCode(postalCode) {
  const cleanCode = postalCode.replace(/-/g, "");
  if (!/^\d{7}$/.test(cleanCode)) return null;
  try {
    const response = await fetch(`${POSTAL_CODE_API_URL}/${cleanCode}`);
    if (!response.ok) return null;
    const json = await response.json();
    if (!json.success || !json.data) return null;
    const data = json.data,
      provinceCode = String(parseInt(data.provinceCode, 10));
    return {
      pref: PROVINCE_CODE_TO_NAME[provinceCode] || "",
      city: data.city || "",
      town: data.town || "",
    };
  } catch {
    return null;
  }
}
function initPostalCodeLookup() {
  const zipInputs = undefined;
  document
    .querySelectorAll('input[name="address[zip]"], input[name="zip"]')
    .forEach((zipInput) => {
      if (zipInput.dataset.postalCodeLookupInitialized) return;
      zipInput.dataset.postalCodeLookupInitialized = "true";
      const wrapper = document.createElement("div");
      wrapper.className = "wl-postal-code-lookup-wrapper";
      const lookupBtn = document.createElement("button");
      ((lookupBtn.type = "button"),
        (lookupBtn.className = "wl-postal-code-lookup-btn"),
        (lookupBtn.textContent = "住所検索"));
      const messageEl = document.createElement("div");
      ((messageEl.className = "wl-postal-code-lookup-message"),
        (messageEl.style.display = "none"));
      const fieldParent = zipInput.closest(".field");
      fieldParent &&
        fieldParent.parentElement &&
        (fieldParent.parentElement.insertBefore(
          wrapper,
          fieldParent.nextSibling,
        ),
        wrapper.appendChild(fieldParent),
        wrapper.appendChild(lookupBtn),
        wrapper.parentElement.insertBefore(messageEl, wrapper.nextSibling));
      const findFormFields = () => {
        const form = zipInput.closest("form");
        if (!form) return null;
        const zipId = undefined,
          idSuffix = (zipInput.id || "")
            .replace(/^cf-zip_?/, "")
            .replace(/^cf-zip$/, "");
        let provinceSelect = null;
        (idSuffix &&
          (provinceSelect = form.querySelector(`#AddressProvince_${idSuffix}`)),
          provinceSelect ||
            (provinceSelect = form.querySelector(
              'select[name="address[province]"], select[name="provinceCode"]',
            )),
          provinceSelect ||
            (provinceSelect = form.querySelector(
              'select[id^="AddressProvince"]',
            )));
        let cityInput = null;
        (idSuffix && (cityInput = form.querySelector(`#cf-city_${idSuffix}`)),
          cityInput ||
            (cityInput = form.querySelector(
              'input[name="address[city]"], input[name="city"]',
            )));
        let townInput = null, address1Input = null, address2Input = null;
        return (
          idSuffix && (townInput = form.querySelector(`#cf-town_${idSuffix}`)),
          townInput ||
            (townInput = form.querySelector(
              'input[name="address[town]"], input[name="town"]',
            )),
          idSuffix && (address1Input = form.querySelector(`#cf-address1_${idSuffix}`)),
          address1Input ||
            (address1Input = form.querySelector(
              'input[name="address[address1]"], input[name="address1"], input[name="address_line1"]',
            )),
          idSuffix && (address2Input = form.querySelector(`#cf-address2_${idSuffix}`)),
          address2Input ||
            (address2Input = form.querySelector(
              'input[name="address[address2]"], input[name="address2"]',
            )),
          {
            provinceSelect: provinceSelect,
            cityInput: cityInput,
            townInput: townInput,
            address1Input: address1Input,
            address2Input: address2Input,
          }
        );
      };
      lookupBtn.addEventListener("click", async () => {
        var _a;
        const postalCode = zipInput.value;
        // if (!postalCode || 7 !== postalCode.replace(/-/g, "").length)
        //   return (
        //     (messageEl.textContent = "郵便番号は7桁の数字で入力してください"),
        //     (messageEl.style.display = "block"),
        //     void (messageEl.className = "wl-postal-code-lookup-message error")
        //   );
        ((lookupBtn.disabled = !0),
          (lookupBtn.textContent = "検索中..."),
          (messageEl.style.display = "none"));
        const result = await lookupPostalCode(postalCode);
        if (
          ((lookupBtn.disabled = !1),
          (lookupBtn.textContent = "住所検索"),
          result.pref)
        ) {
          const fields = findFormFields();
          if (fields) {
            if (fields.provinceSelect) {
              const options = fields.provinceSelect.options;
              for (let i = 0; i < options.length; i++)
                if (
                  options[i].value === result.pref ||
                  (null == (_a = options[i].textContent)
                    ? void 0
                    : _a.trim()) === result.pref
                ) {
                  fields.provinceSelect.selectedIndex = i;
                  break;
                }
            }
            let processedCity = result.city || "";
            let processedTown = result.town || "";
            let processedAddress1 = fields.address1Input ? fields.address1Input.value : "";
            let processedAddress2 = fields.address2Input ? fields.address2Input.value : "";
            
            if (processedCity.length > 10) {
              const cityOverflow = processedCity.substring(10);
              processedCity = processedCity.substring(0, 10);
              processedTown = cityOverflow + processedTown;
            }
            if (processedTown.length > 10) {
              const townOverflow = processedTown.substring(10);
              processedTown = processedTown.substring(0, 10);
              processedAddress1 = townOverflow + processedAddress1;
            }
            if (processedAddress1.length > 10) {
              const address1Overflow = processedAddress1.substring(10);
              processedAddress1 = processedAddress1.substring(0, 10);
              processedAddress2 = address1Overflow + processedAddress2;
            }
            if (processedAddress2.length > 30) {
              processedAddress2 = processedAddress2.substring(0, 30);
            }
            
            fields.cityInput && (fields.cityInput.value = processedCity);
            fields.townInput && (fields.townInput.value = processedTown);
            fields.address1Input && (fields.address1Input.value = processedAddress1);
            fields.address2Input && (fields.address2Input.value = processedAddress2);
          }
          messageEl.style.display = "none";
        } else
          ((messageEl.textContent = "該当する住所が見つかりませんでした"),
            (messageEl.style.display = "block"),
            (messageEl.className = "wl-postal-code-lookup-message error"));
      });
    });
}
("loading" === document.readyState
  ? document.addEventListener("DOMContentLoaded", initPostalCodeLookup)
  : initPostalCodeLookup(),
  (window.initPostalCodeLookup = initPostalCodeLookup));
